






















































































































import Vue from 'vue'

import isEmail from 'validator/lib/isEmail'

export default {
  name: 'contribute-modal',
  components: {
  },
  data() {
    return {
      email1: this.$store.getters['auth/email'],
      email2: this.$store.getters['auth/email'],
      product: '1-year-standard',
      pricing: {
        standard: 3,
        reduced: 2,
        supporter: 5,
        currency: 'EUR'
      },
      forceErrorMessage: false,
      loading: false,
      success: false,
      initialized: false
    }
  },
  mounted() {
    Vue.http.get(Vue.config.server + '/api/pricing')
    .then(response => {
      const pricing = response.body
      pricing.standard = Math.round(pricing.standard / 12 * 100) / 100
      pricing.reduced = Math.round(pricing.reduced / 12 * 100) / 100
      pricing.supporter = Math.round(pricing.supporter / 12 * 100) / 100
      if (pricing.currency) {
        this.pricing = pricing
      }
    })
  },
  computed: {
    emailOk() {
      if (!this.email1 || !this.email2) return null
      if (this.email1 !== this.email2) return false
      if (!isEmail(this.email1)) return false
      if (!isEmail(this.email2)) return false
      return true
    },
    currencySymbol() {
      return String(this.pricing.currency).replace('EUR', '€').replace('USD', '$').replace('GBP', '£')
    }
  },
  methods: {
    close() {
      this.$store.dispatch('runtime/closeModal')
      if (document.location.hash === '#/contribute') document.location.hash = '#/'
    },
    contribute() {
      if (!this.emailOk) {
        this.forceErrorMessage = true
        setTimeout(this.clearErrorMessage, 2000)
        return
      }
      this.contributeWebsite()
    },
    clearErrorMessage() {
      this.forceErrorMessage = false
    },
    contributeWebsite() {
      const locale = this.$store.state.persistent.lang
      this.loading = true
      let productId
      if (this.product === '1-year-standard') {
        productId = '540669'
      } else if (this.product === '1-year-reduced') {
        productId = '540704'
      } else if (this.product === '1-year-supporter') {
        productId = '556897'
      } else {
        throw Error('invalid product id')
      }
      setTimeout(() => this.$store.dispatch('runtime/showModal', 'login'), 10000)
      window.open(Vue.config.server + `/api/contribute?product=${productId}&locale=${locale}&email=${this.email1}`, '_top')
    }
  },
  watch: {
    email1() {
      this.clearErrorMessage()
    },
    email2() {
      this.clearErrorMessage()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/contribute.vue